import { Gradient, LauncherDiv, ProjectLogo, TextProject } from "./style";
import ConsultLoader from "../useIconpark/Consult";

const Launcher = () => {
  return (
    <>
      <LauncherDiv>
        <Gradient></Gradient>
        <ProjectLogo>
            <ConsultLoader size={200} trigger="loop" />
        </ProjectLogo>
        <TextProject>
            <h2>Hush Talk</h2>
        </TextProject>
      </LauncherDiv>
    </>
  );
};

export default Launcher;
